// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Footer() {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'space-between', p: '24px 16px 0px', mt: 'auto' }}
    >
      <Typography variant="caption">&copy; {new Date().getFullYear()} NextGen GTN&trade;. All rights reserved.</Typography>
      <Typography variant="caption">
        Developed by{' '}
        <Link
          href="https://binarymindtechnologies.com/"
          target="_blank"
          rel="noopener"
          underline="hover"
          sx={{ color: 'primary.main', fontWeight: 600 }}
        >
          BinaryMind Technologies
        </Link>
      </Typography>
    </Stack>
  );
}
